import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { useBreedConstants } from "@/app/hooks/useBreedConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useUtils } from "@/app/hooks/useUtils";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect, useState } from "react";

interface PetInformationProps {
  source?: string;
}

const FungalStaining = ({ source }: PetInformationProps) => {
  const { getRouteKey } = useRouter();
  const { formatDate } = useUtils();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerDetails, petDetails } = routeState.state as ICustomerProfileState;
  const { catBreeds, dogBreeds, giantBreeds } = useBreedConstants();
  const [formData, setFormData] = useState({
    petName: "",
    petSpecies: "",
    petGender: "",
    petBreed: "",
    petDOB: "",
    ownerName: "",
    contactNumber: "",
    ownerAddress: "",
    date: null,
    petColor: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const breadDetection = (petSpeciesId, petBreedId) => {
    if (petSpeciesId === "1") {
      const filteredCatBreeds = dogBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "2") {
      const filteredCatBreeds = catBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "15") {
      const filteredGiantBreeds = giantBreeds.filter((giantBreed) => giantBreed.id === petBreedId);
      return filteredGiantBreeds[0]?.pet_breed;
    } else {
      return "Other";
    }
  };

  useEffect(() => {
    if (petDetails && customerDetails) {
      setFormData((prevData) => ({
        ...prevData,
        petName: petDetails?.name,
        petSpecies: petDetails?.pet_species_type_id === "1" ? "DOG" : "CAT",
        petGender: petDetails?.gender,
        petDOB: petDetails?.dob,
        petBreed: breadDetection(petDetails?.pet_species_type_id, petDetails?.pet_breed_id),
        ownerName: customerDetails?.name,
        contactNumber: customerDetails?.mobile,
        date: formatDate(),
        petColor: "",
      }));
    }
  }, [customerDetails, petDetails]);

  const data = [
    { label: "Pet Name", key: "petName" },
    { label: "Pet Species", key: "petSpecies" },
    { label: "Pet Breed", key: "petBreed" },
    { label: "Pet Gender", key: "petGender" },
    { label: "Pet DOB", key: "petDOB" },
    { label: "Owner Name", key: "ownerName" },
    { label: "Contact Number", key: "contactNumber" },
    { label: "Date", key: "date" },
    { label: "Pet Color", key: "color" },
  ];

  return (
    <div className="mb-2">
      <div className="bg-white">
        <table className="w-full border-none flex">
          <tbody>
            {(source === "HELTH" ? data : data.slice(0, -1)).map(({ label, key }) => (
              <tr key={key}>
                <td className="font-semibold text-xs">{label}:</td>
                <td>
                  <input
                    type="text"
                    className="border w-[200px] p-1 focus:outline-none text-xs"
                    value={formData[key as keyof typeof formData]}
                    onChange={(e) => handleInputChange(e, key)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="gap-2 flex items-center w-full pt-3">
          <p className="text-sm w-[280px]">Hair Loss / Circular Lesion Present:</p>
          <input type="text" className="text-sm w-[400px] border p-1" />
        </div>

        <div className="gap-2 flex items-center w-full pt-3">
          <p className="text-sm w-[280px]">Other Pets Affected:</p>
          <input type="text" className="text-sm w-[400px] border p-1" />
        </div>

        <div className="gap-2 flex items-center w-full pt-3">
          <p className="text-sm w-[280px]">Human Contact Affected:</p>
          <input type="text" className="text-sm w-[400px] border p-1" />
        </div>

        <div className="gap-2 flex items-center w-full pt-3">
          <p className="text-sm w-[280px]">Previous Antifungal Treatment:</p>
          <input type="text" className="text-sm w-[400px] border p-1" />
        </div>
      </div>
      <style>
        {`
          @media print {
            input {
              border: none;
            }
          }
        `}
      </style>
    </div>
  );
};

export default FungalStaining;
